export default __webpack_public_path__ + "static/media/Lift_newlogo.dd97d581.jpg";